import { createContext, useContext, useEffect, useState } from 'react'
import { useProvider } from '../App'
import { getCategories } from '../lib/getProvider'
import { config } from '../config/config'
import { ProviderData } from '../lib/URLGenerator'

// Create Context
const ProviderCtx = createContext({})
export const useProviderContext = () => useContext(ProviderCtx)

export const ProviderContext = ({ children }) => {
    // const { isLoading, error, data: providers } = useProvider()
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState(null)
    const [providers, setProviders] = useState([])
    const [filters, setFilters] = useState([])
    const [options, setOptions] = useState({
        zoom: config.map.zoom_level.default,
        center: {
            lat: config.map.center.default.lat,
            lng: config.map.center.default.lng
        },
        postcode: config.map.postcodes.default,
        location_status: 'OK'
    })

    const kmlPath = document.getElementById('root').dataset['kmlFileUrl'] ?? process.env.REACT_APP_KML_REMOTE;
    const KML_URL =
        process.env.REACT_APP_CONTEXT === 'develop'
            ? process.env.REACT_APP_KML_LOCAL
            : kmlPath;

    useEffect(() => {
        fetch(ProviderData())
            .then(res => res.json())
            .then(data => {
                setIsLoading(false)
                setProviders(data)
            })
            .catch(error => {
                setIsLoading(false)
                setError(error)
            })
    }, [])

    useEffect(() => {
        if (providers && providers.length > 0) {
            setFilters(getCategories(providers).map(({ cssClass }) => (cssClass)))
        }

        return () => {
            setFilters([])
        }
    }, [providers])

    return (
            <ProviderCtx.Provider value={{
                isLoading,
                error,
                providers,
                filters,
                setFilters,
                options,
                setOptions,
                KML_URL,
                config
            }}>
                {children}
            </ProviderCtx.Provider>
    )
}

export default ProviderContext
